"use client";

import React from "react";
import { MapPin, Phone, Mail, Facebook, Instagram, MessageCircle, Heart } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading,
    error
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-2">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-[var(--ring)]/20 animate-pulse rounded" />)}
      </div>;
  }
  if (error) {
    return <div className="text-sm opacity-70">Menu non disponibile</div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="space-y-2">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="hover:text-white transition-colors duration-300 text-sm font-medium">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function PieDiPagina() {
  const currentYear = new Date().getFullYear();
  return <section id="piè-di-pagina" className="bg-primary text-[var(--ring)] py-16 border-t border-[var(--ring)]/20">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-12">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562811/img/image_x5pul30q.png" alt="Dolci Sapori Logo" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-sm leading-relaxed opacity-90 max-w-xs">
              Dolci Sapori porta in tavola l'autentica tradizione siciliana. 
              Ogni dolce è un'opera d'arte, creata con passione, ingredienti freschi 
              e ricette tramandate da generazioni.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif text-xl font-semibold tracking-wide">Navigazione Veloce</h3>
            <MenuProvider menu_id="25" className="w-full">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif text-xl font-semibold tracking-wide">Contatti</h3>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3" data-index="0">
                <MapPin className="w-5 h-5 shrink-0 mt-0.5 opacity-80" />
                <span>Dolci Sapori di Tulone Alfonso, Via Cappuccini 33/C, 92019 Sciacca (AG)</span>
              </li>
              <li className="ml-8 opacity-80">P.IVA: 02118980842</li>
              <li className="ml-8 opacity-80">C.F.: TLNLNS63B24I533Y</li>
              <li className="flex items-center gap-3" data-index="1">
                <Phone className="w-5 h-5 shrink-0 opacity-80" />
                <Link to="tel:+390924999999" className="hover:text-white transition-colors">+39 0925 86986</Link>
              </li>
              <li className="flex items-center gap-3" data-index="2">
                <Mail className="w-5 h-5 shrink-0 opacity-80" />
                <Link to="mailto:info@dolcisapori.com" className="hover:text-white transition-colors">danielasabella099@gmail.com</Link>
              </li>
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif text-xl font-semibold tracking-wide">Seguici</h3>
            <div className="flex gap-4">
              <Link to="https://www.facebook.com/profile.php?id=100063475904470&sk=directory_links" newTab className="p-2 rounded-full border border-[var(--ring)]/30 hover:bg-[var(--ring)] hover:text-primary transition-all duration-300 flex items-center justify-center" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </Link>
              <Link to="https://www.instagram.com/dolci_sapori31/" newTab className="p-2 rounded-full border border-[var(--ring)]/30 hover:bg-[var(--ring)] hover:text-primary transition-all duration-300 flex items-center justify-center" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </Link>
              <Link to="https://wa.me/393402498369" newTab className="p-2 rounded-full border border-[var(--ring)]/30 hover:bg-[var(--ring)] hover:text-primary transition-all duration-300 flex items-center justify-center" aria-label="WhatsApp">
                <MessageCircle className="w-5 h-5" />
              </Link>
            </div>
            
            <div className="mt-2">
              <Button asChild variant="outline" className="w-full border-[var(--ring)] text-[var(--ring)] hover:bg-[var(--ring)] hover:text-primary bg-transparent">
                <Link to="https://maps.app.goo.gl/G2hTbpkwF4QJ7QTL7" newTab>
                  <MapPin className="w-4 h-4 mr-2" />
                  Vedi su Mappa
                </Link>
              </Button>
            </div>
          </div>
        </div>

        <Separator className="bg-[var(--ring)]/20 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs opacity-80">
          <p>© {currentYear} Dolci Sapori. Tutti i diritti riservati.</p>
          
          <div className="flex items-center gap-2">
            <span>Fatto con</span>
            <Heart className="w-3 h-3 fill-current text-red-500" />
            <span>in Sicilia</span>
          </div>
        </div>
      </div>
    </section>;
}